import Footer from "@/components/Footer";
import Header from "../components/Header";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { useLanguage } from "@/contexts/LanguageContext";

const About = () => {
  const { t } = useLanguage();

  const teamMembers = [
    {
      id: 1,
      name: "Dr Abdellahi Med Yacoub",
      role: "Directeur Scientifique et Formation Medicale",
      image: "/team/DS.png"
    },
    {
      id: 2,
      name: "Hamoud El Jeylani",
      role: "Directeur Commercial",
      image: "/team/DC.png"
    },
    {
      id: 3,
      name: "Khady Cheikh Talibouya Cisse",
      role: "Directrice Technique",
      image: "/team/DT.png"
    },
    {
      id: 4,
      name: "Sidi Med Tichity",
      role: "Directeur Marketing",
      image: "/team/DM.png"
    },
    {
      id: 5,
      name: "Hanan MedAbba",
      role: "Directrice des affaires reglementaires",
      image: "/team/DAR.png"
    }
  ];

  return (
    <div className="min-h-screen bg-gray-50">
      <Header />
      
      {/* Hero Section */}
      <section className="bg-gradient-to-r from-blue-600 to-blue-900 text-white py-10">
        <div className="container mx-auto px-4 text-center">
          <h1 className="text-4xl md:text-5xl font-bold mb-6">
            {t('about.title')}
          </h1>
          <p className="text-xl md:text-lg max-w-l mx-auto">
            {t('about.subtitle')}
          </p>
        </div>
      </section>

      {/* Company Overview */}
      <section className="py-16">
        <div className="container mx-auto px-4">
          <div className="grid md:grid-cols-2 gap-12 items-center">
            <div>
              <h2 className="text-3xl font-bold text-gray-800 mb-6">
                {t('about.history.title')}
              </h2>
              <p className="text-gray-600 mb-4">
                {t('about.history.p1')}
              </p>
              <p className="text-gray-600 mb-4">
                {t('about.history.p2')}
              </p>
              <p className="text-gray-600 mb-4">
                {t('about.history.p3')}
              </p>
            </div>
            <div>
              <img 
                src="/placeholder.svg" 
                alt="Notre équipe" 
                className="rounded-lg shadow-lg w-full h-96 object-cover"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Values Section */}
      <section className="py-16 bg-white">
        <div className="container mx-auto px-4">
          <h2 className="text-3xl font-bold text-center text-gray-800 mb-12">
            {t('about.values.title')}
          </h2>
          <div className="grid md:grid-cols-3 gap-8">
            <Card>
              <CardHeader>
                <CardTitle className="text-blue-600">{t('about.excellence.title')}</CardTitle>
              </CardHeader>
              <CardContent>
                <CardDescription>
                  {t('about.excellence.desc')}
                </CardDescription>
              </CardContent>
            </Card>
            
            <Card>
              <CardHeader>
                <CardTitle className="text-blue-600">{t('about.innovation.title')}</CardTitle>
              </CardHeader>
              <CardContent>
                <CardDescription>
                  {t('about.innovation.desc')}
                </CardDescription>
              </CardContent>
            </Card>
            
            <Card>
              <CardHeader>
                <CardTitle className="text-blue-600">{t('about.trust.title')}</CardTitle>
              </CardHeader>
              <CardContent>
                <CardDescription>
                  {t('about.trust.desc')}
                </CardDescription>
              </CardContent>
            </Card>
          </div>
        </div>
      </section>

      {/* ceo Section */}
      <section className="py-16">
        <div className="container mx-auto px-10">
          <div className="grid md:grid-cols-2 gap-12 items-center">
          <div>
              <img 
                src="team/DG.png" 
                alt="Dr Ahmed Aly" 
                className="rounded-lg shadow-lg w-full h-96 object-cover"
              />
              <h3 className="text-3xl text-center font-semibold text-gray-800 mb-2">
                Dr Ahmed Aly
              </h3>
            </div>
            <div>
              <h2 className="text-3xl font-bold text-gray-800 mb-6">
                {t('about.ceo.title')}
              </h2>
              <p className="text-gray-600 mb-4">
                {t('about.ceo.p1')}
              </p>
            </div>
            
          </div>
        </div>
      </section>

      {/* Team Section */}
      <section className="py-16">
        <div className="container mx-auto px-4">
          <h2 className="text-3xl font-bold text-center text-gray-800 mb-12">
            {t('about.team.title')}
          </h2>
          <p className="text-gray-600 mb-4">
            {t('about.team.p1')}
          </p>
          <div className="grid md:grid-cols-5 gap-8">
            {teamMembers.map((member) => (
              <div key={member.id} className="text-center">
                <img 
                  src={member.image}
                  alt={member.name}
                  className="w-32 h-32 rounded-full mx-auto mb-4 object-cover bg-gray-100"
                />
                <h3 className="text-xl font-semibold text-gray-800 mb-2">
                  {member.name}
                </h3>
                <p className="text-gray-600">{member.role}</p>
              </div>
            ))}
          </div>
        </div>
      </section>
      <Footer />
    </div>
  );
};

export default About;
